import { IModel } from "@/@types/models/model";
import coreFields from "./helpers/coreFields";

const DynamicFormsModel: IModel = {
  title: 'DynamicForms',
  apiPath: 'system/forms',
  forms: {
    default: {
      fields: ['id', 'title', 'title_ttoken', 'mw_procedure_name', 'app_permission_id'],
    },
  }, 
  listViews: {
    default: {
      fields: ['id', 'title', 'title_ttoken', 'mw_procedure_name', 'app_permission_id'],
    },
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    coreFields.created_by,
    coreFields.modified_on,
    coreFields.modified_by,
    {
      title: 'title',
      source: 'title',
      ttoken: 'admin:common.title',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'title_ttoken',
      source: 'title_ttoken',
      ttoken: 'admin:common.title_ttoken',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'mw_procedure_name',
      source: 'mw_procedure_name',
      ttoken: 'admin:common.mw_procedure_name',
      type: 'text',
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'app_permission_id',
      source: 'app_permission_id',
      ttoken: 'admin:common.app_permission_id',
      type: 'picker',
      subModel: {
        apiPath: 'system/app_permissions?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      translate: true,
    },
  ], 
}

export default DynamicFormsModel;
